import React from 'react';

export const Kommunikasjon = () => {
  return (
    <>
      Kommunikasjon page
    </>
  )
}